import React from 'react';
import Paper from "@material-ui/core/es/Paper";
import Divider from "@material-ui/core/es/Divider";
import Icon from "@material-ui/core/es/Icon";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Link from "react-router-dom/es/Link";
import classnames from 'classnames';
import Grid from "@material-ui/core/es/Grid";

const PageBase = ({title, navigation, children, icon, classes, link}) => {

    return (
        <Paper>
            <Link to={link} className={classnames(classes.header, 'page-base-header')}>
                <div className={classes.titleWrapper}>
                    <Grid container>
                        <Grid item xs={2}>
                            <Icon color="primary" className={classes.icon}>{icon}</Icon>
                        </Grid>
                        <Grid item>
                            <span className={classes.title}>
                                {title}
                            </span>
                        </Grid>
                    </Grid>
                    {/*<Icon></Icon>*/}
                </div>
            </Link>
            <Divider/>
            <div className={classes.content}>
                {children}
            </div>
        </Paper>
    );
};

const styles = theme => ({
    content: {
        padding: 20
    },
    titleWrapper: {
        color: 'rgba(0,0,0,0.65)',
        display: 'table-cell',
        fontSize: '24px',
        lineHeight: '32px',
        verticalAlign: 'middle'
    },
    title: {
        flex: 1,
        lineHeight: '38px'
    },
    header: {
        padding: '30px 20px',
        display: 'block',
    },
    icon: {
        paddingRight: 20,
        fontSize: 35
    }
});

export default withStyles(styles)(PageBase);



// WEBPACK FOOTER //
// ./src/components/PageBase.js